/* template */
<template><mpx-web-view :src="(pageUrl)" @load="loadSuccess" @error="loadFail" v-if="(pageUrl)"/></template>

/* styles */
<style mpxStyleOptions='{"mid":"m304b8f1c"}'>
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m304b8f1c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./webview.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./webview.mpx?ctorType=page&index=0&isPage&mpx&type=script")
  const currentOption = global.__mpxOptionsMap["m304b8f1c"]
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"navigationBarBackgroundColor":"#ffffff","navigationBarTextStyle":"black"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-web-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-web-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
